<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="23"
        viewBox="0 0 20 23"
    >
        <path
            id="Polygon_2"
            data-name="Polygon 2"
            d="M9.766,3.015a2,2,0,0,1,3.468,0L21.277,17a2,2,0,0,1-1.734,3H3.457a2,2,0,0,1-1.734-3Z"
            transform="translate(20) rotate(90)"
            fill="#dbdbdb"
        />
    </svg>
</template>
